import {useExp1ProductMap} from 'hooks/useExp1ProductMap'
import {Ventrata} from 'types'
import {formatMoney} from 'utils/formatMoney'
import {ConfirmationPagePromotion} from '../widgets/ConfirmationPagePromotion'
import {CartItem} from './CartItem'

type Props = {
  order: Ventrata.Order | null
}

export const CartItems = ({order}: Props) => {
  const exp1ProductMap = useExp1ProductMap(order)

  if (!order) {
    return <div>Your cart is empty</div>
  }

  return (
    <div className="flex flex-col gap-4 w-full d:w-[568px]">
      {order.bookings.map((booking) => {
        const exp1Product = exp1ProductMap[booking.product.id]
        return <CartItem key={booking.uuid} booking={booking} exp1Product={exp1Product} />
      })}
      <div className="flex justify-end font-bold">
        Total {formatMoney(order.pricing?.retail, order.pricing?.currency)}
      </div>

      <ConfirmationPagePromotion order={order} className="mt-8" />
    </div>
  )
}
